<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         label-width="80px">
                    <el-row class="mt15 mb10">
                        <el-col :span="6" class="mb0">
                            <el-form-item label="活动状态">
                                <el-select clearable @change="pageList()" v-model="queryParams.status" placeholder="请选择">
                                    <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="活动级别">
                                <el-select clearable @change="pageList()" v-model="queryParams.activityLevel" placeholder="请选择">
                                    <el-option v-for="item in activityLevelList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="活动方向">
                                <el-select clearable @change="pageList()" v-model="queryParams.activityDirection" placeholder="请选择">
                                    <el-option v-for="item in activityDirList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.activityName" placeholder="请输入名称" class="input-with-select">
                                    <template #append>
                                        <el-button @click="pageList" type="primary" style="background-color: #3b62f8;color: #fff"  icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>


            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card :body-style="{ padding: '0px' }" class="course-one" @click="viewInfo(item)">
                                    <div class="course-name">{{item.activityName}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100"  :src="item.activityCover" alt />
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject">
                                                <div class="status-info-bm" v-if="item.status===1">报名阶段</div>
                                                <div class="status-info-cs" v-if="item.status===2">初审阶段</div>
                                                <div class="status-info-fs" v-if="item.status===3">复审阶段</div>
                                                <div class="status-info-zs" v-if="item.status===4">终审阶段</div>
                                                <div class="status-info-zs" v-if="item.status===5">现场评比</div>
                                                <div class="status-info-js" v-if="item.status===6">活动结束</div>
                                            </div>
                                            <div class="course-team-user">活动级别:{{item.activityLevelName}}</div>
                                            <div class="course-team-user">活动方向:{{item.activityDirectionName}}</div>
                                            <div class="course-team-user">活动负责:{{item.activityLeaderName}}</div>
                                            <div class="course-team-user">活动单位:{{item.hostOrgName}}</div>

                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageList" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <activity-info :info-id="this.infoId" @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import activityInfo from "@/components/teachResearch/activityInfo.vue";
import {activityPageWeb} from "@/api/admin/activity";

export default {
    name:'pageActivity',
    components:{activityInfo, pageTag, dataEmpty},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageList();
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        if (this.$store.state.params.jumpParams.infoId){
            this.infoId = this.$store.state.params.jumpParams.infoId;
            this.showMode = "detail"
            this.$emit('change-mode',this.showMode);
        }
        this.getQueryDict();
        this.pageList();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            itemName:'课题引领',
            itemKey:'',
            queryParams: {
                activityName: '',
                status: '',
                activityDirection: '',
                activityLevel: '',
                pageNum: 1,
                pageSize: 6,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            infoId:'',
            natureList:[],
            statusList: [
                { name: '报名阶段', value: 1 },
                { name: '初审阶段', value: 2 },
                { name: '复审阶段', value: 3 },
                { name: '终审阶段', value: 4 },
                { name: '现场评比', value: 5 },
                { name: '活动结束', value: 6 },
            ],
            activityLevelList:[],
            activityDirList:[],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'activity_level' }).then(res => {
                this.activityLevelList = res.data.data;
            })
            queryDict({ code: 'activity_direction' }).then(res => {
                this.activityDirList = res.data.data;
            })
        },
        pageList(){
            activityPageWeb(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;
            });
        },
        viewInfo(item){
            this.showMode = "detail"
            this.infoId = item.activityId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
}
.form-box{
    width: 98%;
    height: auto;
    margin: auto;
    //border-bottom: 2px solid #3b62f8;
    background-color: #fff;
    padding-top: 5px;
}
.right-container{
    width: 100%;
    height: auto;
}
/deep/ .head-name{
    background-color: #6e99c8!important;
    color: #fff;
    font-size: 15px;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #3b62f8;
}
.info-list-container{
    width: 100%;
    height: calc(100vh - 220px)!important;
    margin: auto;
    overflow-x: hidden;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-right: 10px;
    padding-top: 10px;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding-left: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 110px;
    padding-top: 5px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 45px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 25px;
    display: flex;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #00a173;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-fs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-zs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-js{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #54bcbd;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}


.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>